<template>
  <div v-bind:class="{ 'code-qr-container': lightMode }">
    <div v-bind:class="{ 'content-container': !lightMode, 'content-container-light': lightMode }">
      <div class="title-container">
        <div class="pds-typography-h5  pds-typography-bold"><b>Reconocimiento Facial</b></div>
      </div>
      <div class="info-container">
        <div class="info-box">
          <div class="pds-typography-h6 start-subtitle-container">Recuerda lo siguiente:</div>
          <div class="loading-steps-container">
            <div class=" pds-typography-body-16 step-information-container">
              <span class="icon-container">
                <vue-feather type="check-circle" size="22" stroke-width="2" stroke="#0061a0"></vue-feather>
              </span>
              <div v-bind:class="{ message: !lightMode, 'message-light': lightMode }">
                Busca tu
                <span class="pds-typography-bold">cédula de identidad válida</span>
              </div>
            </div>
            <div class=" pds-typography-body-16 step-information-container">
              <span class="icon-container">
                <vue-feather type="check-circle" size="22" stroke-width="2" stroke="#0061a0"></vue-feather>
              </span>
              <div v-bind:class="{ message: !lightMode, 'message-light': lightMode }">
                Tienes
                <span class="pds-typography-bold">15 minutos</span>
                para completar los pasos
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-bind:class="{ 'border-container': !lightMode, 'border-container-light': lightMode }">
        <div class=" pds-typography-h5 subtitle-container">Usa tu teléfono móvil para escanear el código QR</div>
        <div class="container-code-qr" :class="{ 'has-pointer': canContinueOnDesktop }" @click="onQRCodeClick">
          <qrcode-vue :value="urlCode" size="300" level="L"></qrcode-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../../utils/config.js";
import QrcodeVue from "qrcode.vue";
import FRConstants from "@/components/facialRecognition/constants/facialRecognitionConstant";
import VueFeather from "vue-feather";
export default {
  name: "CodeQR",
  components: {
    QrcodeVue,
    VueFeather,
  },
  props: {
    transactionId: { type: String, required: true },
    kongToken: { type: String, required: true },
    wrapperUrl: { type: String, required: true },
    traceId: { type: String, required: true },
    company: { type: String, default: "principal" },
    dummyMode: { type: Boolean, default: false },
    lightMode: { type: Boolean, default: false },
    facialTimer: { type: String, default: "6" },
    config: { type: Object, required: true },
    kongModeJWT: { type: Boolean, required: true },
    portalId: { type: String },
    dummyResult: { type: String, default: FRConstants.resultTypes.success },
  },
  data() {
    let urlCode = this.wrapperUrl;
    urlCode = `${urlCode}?transactionId=${this.transactionId}`
                        +`&token=${this.kongToken}`
                        +`&traceId=${this.traceId}`
                        +`&tabTimer=${this.facialTimer}`
                        +`&isFromDesktop=1`
                        +`&company=${this.company}`;
    if (this.dummyMode) {
      urlCode = `${urlCode}&dummyMode=${this.dummyMode}&dummyResult=${this.dummyResult}`;
    }
    if (this.config.environment !== Config.buildEnvironment()) {
      urlCode = `${urlCode}&env=${this.config.environment}`;
    }
    if (this.kongModeJWT) {
      urlCode = `${urlCode}&jwtMode=${this.kongModeJWT}`;
    }
    if (this.portalId) {
      urlCode = `${urlCode}&portalId=${this.portalId}`;
    }
    return {
      urlCode: urlCode,
      canContinueOnDesktop: !this.config.isProd(),
      companyLink: this.company === "principal" ? "Principal.cl" : "Cuprum.cl",
    };
  },
  methods: {
    onQRCodeClick() {
      if (this.canContinueOnDesktop) {
        window.open(this.urlCode);
      }
    },
  },
};
</script>
<style scoped src="@pds/typography/typography.min.css"></style>
<style scoped>
/*noinspection CssUnusedSymbol*/
.has-pointer {
  cursor: pointer;
}

.code-qr-container {
  height: inherit;
}

.subtitle-container {
  text-align: center;
  color: #333333;
  line-height: 34px;
  width: 340px;
}

.start-subtitle-container {
  color: #333333;
  width: 340px;
  padding: 10px 0;
}

.container-code-qr {
  margin: 2em;
}

.icon-container {
  margin-bottom: -3px;
}

.info-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-radius: 5px;
  min-width: 450px;
  max-width: 640px;
  width: 100%;
  height: 200px;
}

.step-information-container {
  display: flex;
  padding: 6px 0;
  text-align: left;
}

.content-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 645px;
  margin: auto;
  padding: 3em 0;
  width: 90%;
}

.content-container-light {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 645px;
  margin: auto;
  height: inherit;
}

.message {
  width: 100%;
  max-width: calc(500px + 3em);
  padding: 0 9px;
  align-self: center;
}

.message-light {
  width: 100%;
  max-width: calc(500px + 5em);
}

.title-container {
  margin-bottom: 1.5em;
  text-align: center;
  color: #333333;
  max-width: 645px;
}

.border-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 2.25em 1.5em;
  margin-top: 0.75em;
  min-width: 450px;
  max-width: 640px;
  width: 100%;
}

.border-container-light {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.75em;
}
</style>
